
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class LotCreationDetailsGrid extends Serenity.EntityGrid<LotCreationDetailsRow, any> {
        protected getColumnsKey() { return 'Inventory.LotCreationDetails'; }
        protected getDialogType() { return LotCreationDetailsDialog; }
        protected getIdProperty() { return LotCreationDetailsRow.idProperty; }
        protected getInsertPermission() { return LotCreationDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return LotCreationDetailsRow.localTextPrefix; }
        protected getService() { return LotCreationDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}